import {DateTime} from "luxon";

export const getPregnancyDurationDays = (pregnancy: {actualEndDate: DateTime, startDate: DateTime}) => {
    const end = pregnancy.actualEndDate ?? DateTime.now();
    return getDurationDays({start: pregnancy.startDate, end});
};

export const getEstimatedPregnancyDurationDays = (pregnancy: {
    startDate: DateTime,
    calculatedEndDate: DateTime,
}) => getDurationDays({start: pregnancy.startDate, end: pregnancy.calculatedEndDate});

export const getPregnancyRemainingDays = (pregnancy: {
    startDate: DateTime,
    actualEndDate: DateTime,
    calculatedEndDate: DateTime,
}) => {
    const duration = getPregnancyDurationDays(pregnancy);
    const estimatedDuration = getEstimatedPregnancyDurationDays(pregnancy);
    return estimatedDuration - duration;
};

export const getDurationDays = ({start, end}: {start: DateTime, end: DateTime}) => Math.round(end.diff(start).as("days"));

export const formatDays = (days: number) => {
    const weeks = Math.trunc(days / 7);
    const daysLeft = days % 7;
    return Object.entries({w: weeks, d: daysLeft})
        .filter(e => e[1])
        .map(([k, v]) => `${v}${k}`)
        .join(' ');
};

export enum PregnancyState {
    MATED,
    UNSUCCESSFUL,
    PREGNANT,
    COMPLETED,
}

export const getPregnancyState = ({matingDate, startDate, actualEndDate}: {
    matingDate: DateTime | undefined | null,
    startDate: DateTime | undefined | null,
    actualEndDate: DateTime | undefined | null
}): PregnancyState | null => {
    switch (true) {
        case Boolean(matingDate && !startDate && !actualEndDate): return PregnancyState.MATED;
        case Boolean(matingDate && !startDate && actualEndDate): return PregnancyState.UNSUCCESSFUL;
        case Boolean(startDate && !actualEndDate): return PregnancyState.PREGNANT;
        case Boolean(actualEndDate): return PregnancyState.COMPLETED;
        default: return null;
    }
};
